import { Booking, BookingsState } from 'acscp/store/bookingsState';
import { TripStatus } from 'acscp/api/models/tripStatus';

export enum BookingsFilter {
    Enquiries = 'Enquiries',
    Quoted = 'Quoted',
    Booked = 'Booked',
    ItineraryAvailable = 'ItineraryAvailable',
    Flown = 'Flown',
}

export function filterBookingsOnOwnerId(bookings: Booking[], ownerId: string): Booking[] {
    return !ownerId
        ? bookings
        : bookings.filter(value => value.ownerOfBookingId === ownerId);
}

export function filterBookingsOnType(bookings: BookingsState, filter: BookingsFilter): Booking[] {
    switch (filter) {
        case (BookingsFilter.Enquiries):
            return createFilteredBookingList(bookings, 'Enquiry', 'AwaitingQuotes', 'EnquiryExpired');
        case (BookingsFilter.Quoted):
            return createFilteredBookingList(bookings, 'QuotesAvailable', 'Expired');
        case (BookingsFilter.Booked):
            return createFilteredBookingList(bookings, 'FlightPlanning', 'CheckingAvailability', 'ItineraryAvailable');
        case (BookingsFilter.ItineraryAvailable):
            return createFilteredBookingList(bookings, 'ItineraryAvailable');
        case (BookingsFilter.Flown):
            return createFilteredBookingList(bookings, 'Flown');
    }
}

function createFilteredBookingList(bookings: BookingsState, ...allowedStatuses: TripStatus[]): Booking[] {
    const filteredBookings: Booking[] = [];
    for (const key of Object.keys(bookings)) {
        if (bookingHasStatus(bookings[key], allowedStatuses)) {
            filteredBookings.push(bookings[key]);
        }
    }
    return filteredBookings;
}

function bookingHasStatus(booking: Booking, allowedStatuses: TripStatus[]): boolean {
    return allowedStatuses.some(status => status === booking.status);
}
